export default {
  canWrite(context) {
    const rights = context.accessRights;
    const canWrite = rights && context.field && rights[context.field] && rights[context.field].write;
    return canWrite;
  },
  canRead(context) {
    const rights = context.accessRights;
    const canRead = rights && context.field && rights[context.field] && rights[context.field].read;
    return canRead;
  },
  canDelete(context) {
    const rights = context.accessRights;
    const canDelete = rights && context.field && rights[context.field].delete;
    return canDelete;
  }
};
